import React, { useState, useEffect } from "react";
import "./index.scss";
import { setLogoUrl } from "redux/urlEncryption";
import Signdesk_logo from "assets/images/signdesk_logo.svg";
import { getWorkflowData } from "api/formDisplay";
import { Button, Row, Container, Image } from "react-bootstrap";
import tick from "assets/images/Group 2010.svg";
import failedTick from "assets/images/cross.jpg";
import LoadingSpinner from "lib/LoadingSpinner";
import { useSelector, useDispatch } from "react-redux";
import { getOrgInfo } from "api/organisation";
import { getPaymentContentDataTobeDisplayed } from "api/payment";
import { useLocation } from "react-router-dom";
import { setAppColor } from "helper";

const PaymentSucess = () => {
  const paymentModalDetailsToDisplay =
    sessionStorage.getItem("stateData") &&
    JSON.parse(sessionStorage.getItem("stateData"));
  const { state } = useLocation();

  const [paymentContent, setPaymentContent] = useState({});
  const [isPaymentDataLoading, setIsPaymentDataLoading] = useState(true);
  const [isCreateWorkFlowLoading, setIsCreateWorkFlowLoading] = useState(false);
  const decryptedId = useSelector((state) => state?.urlEncryption?.urlId);

  const layoutSetting = useSelector(
    (state) =>
      state?.loggedInUserInfo?.userAuthInfo?.organisationInfo?.layout_setting
  );
  setAppColor(layoutSetting);

  let [logoUrl, setLogoURL] = useState();
  const [poweredBy, setPoweredBy] = useState(false);
  const organisation_id = useSelector(
    (state) => state?.loggedInUserInfo
  ).organisation_id;

  useEffect(() => {
    getOrgInfo({ _id: organisation_id })
      .then((res) => {
        const poweredBy = res?.white_labeled ?? false;
        const logoURL = res?.logo
          ? `https://signdesk.in/company/${res?.logo}`
          : "";
        const list = document.getElementById("favicon_customized");
        const titleName = document.getElementById("title-id");

        if (list && res?.icon) {
          list.href = `https://signdesk.in/company/${res?.icon}`;
        }

        if (titleName && res?.setting?.parent_client_name) {
          titleName.innerText = res?.setting?.parent_client_name;
        }

        setPoweredBy(poweredBy);
        setLogoURL(logoURL);
        setIsCreateWorkFlowLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching organization info:", error);
        setIsCreateWorkFlowLoading(false);
      });
  }, [organisation_id, decryptedId]);

  const dispatch = useDispatch();
  const tickIcon = `<svg class="text-theme" fill="currentColor" xmlns="http://www.w3.org/2000/svg" width="90.818" height="90.818" viewBox="0 0 90.818 90.818">
  <g id="Group_2010" data-name="Group 2010" transform="translate(0 0)">
    <path id="Path_947" data-name="Path 947" d="M173.079,304.959A45.409,45.409,0,1,1,127.67,259.55a45.409,45.409,0,0,1,45.409,45.409Z" transform="translate(-82.261 -259.55)"  opacity="0.1"/>
    <path id="Path_948" data-name="Path 948" d="M156.01,301.639a31.658,31.658,0,1,1-31.657-31.657A31.658,31.658,0,0,1,156.01,301.639Z" transform="translate(-78.77 -256.057)" />
    <path id="Path_949" data-name="Path 949" d="M105.928,296.713l8.854,8.854,21.9-21.9a1.32,1.32,0,0,1,1.863,0l1.4,1.4a1.316,1.316,0,0,1,0,1.863L117.111,309.76l-1.4,1.4a1.317,1.317,0,0,1-1.425.289h0a1.311,1.311,0,0,1-.437-.287l-1.4-1.4-9.786-9.785a1.319,1.319,0,0,1,0-1.865l1.4-1.4a1.318,1.318,0,0,1,1.862,0Z" transform="translate(-75.825 -251.948)" fill="#fff"/>
  </g>
</svg>`;

  useEffect(() => {
    window.history.pushState(null, "", window.location.href);
    window.onpopstate = function () {
      window.history.pushState(null, "", window.location.href);
    };
  }, []);
  useEffect(() => {
    const fetchData = async () => {
      if (!decryptedId?.subWfId) return;

      setIsCreateWorkFlowLoading(true);

      try {
        const response = await getWorkflowData(decryptedId.subWfId);

        if (response?.organisation_id) {
          const res = await getOrgInfo({ _id: response.organisation_id });

          dispatch(setLogoUrl("https://signdesk.in/company/" + res?.logo));

          const list = document.getElementById("favicon_customized");
          // list.href =
          //   "/unified/" +
          //   (res?.fav_icon ? res?.fav_icon : "signdesk_logo@2x.png");
          list.href = res?.icon
            ? `https://signdesk.in/company/${res?.icon}`
            : "https://signdesk.com/images/favicon.png";

          const titleName = document.getElementById("title-id");
          titleName.innerText = res?.setting?.parent_client_name;
        } else {
          dispatch(setLogoUrl("https://signdesk.in/company/signDesk-logo.png"));

          const list = document.getElementById("favicon_customized");
          list.href = "/unified/signdesk_logo@2x.png";

          const titleName = document.getElementById("title-id");
          titleName.innerText = "Signdesk";
        }
      } catch (error) {
        console.error(error);
      } finally {
        setIsCreateWorkFlowLoading(false);
      }
    };

    fetchData();
  }, [decryptedId?.subWfId]);

  useEffect(() => {
    const fetchPaymentData = async () => {
      if (!decryptedId?.paymentLogId) return;

      setIsPaymentDataLoading(true);

      try {
        const paymentContent = await dispatch(
          getPaymentContentDataTobeDisplayed({
            _id: decryptedId.paymentLogId,
          })
        ).unwrap();

        setPaymentContent(paymentContent);
      } catch (error) {
        console.error({ error });
      } finally {
        setIsPaymentDataLoading(false);
      }
    };

    fetchPaymentData();
  }, [decryptedId?.paymentLogId]);

  const windowClose = () => {
    window.close();
  };

  if (isCreateWorkFlowLoading) {
    return <LoadingSpinner />;
  }

  const getHeaderContent = (paymentContent, paymentModalDetailsToDisplay) => {
    if (paymentContent && Object.keys(paymentContent).length > 0) {
      return paymentContent.isPaymentSuccess
        ? paymentContent.success?.header
        : paymentContent.failure?.header;
    } else {
      return paymentModalDetailsToDisplay?.header;
    }
  };

  const getContent = (paymentContent, paymentModalDetailsToDisplay) => {
    if (paymentContent && Object.keys(paymentContent).length > 0) {
      return paymentContent.isPaymentSuccess
        ? paymentContent.success?.content
        : paymentContent.failure?.content;
    } else {
      return paymentModalDetailsToDisplay?.content;
    }
  };

  return (
    <div className="layout-container">
      <div className="logo">
        <Image src={logoUrl} className="client-logo" />
      </div>
      {paymentContent || state || paymentModalDetailsToDisplay ? (
        <div className="parentdiv">
          <Container className="divcontainer">
            <>
              <Row className="headericon">
                {/* <Image
                      src={
                        paymentContent?.isPaymentSuccess ||
                        paymentModalDetailsToDisplay?.isPaymentSuccess
                          ? tick
                          : failedTick
                      }
                    /> */}
                {paymentContent?.isPaymentSuccess ||
                paymentModalDetailsToDisplay?.isPaymentSuccess ? (
                  <span
                    dangerouslySetInnerHTML={{
                      __html: tickIcon,
                    }}
                  ></span>
                ) : (
                  <Image src={failedTick} />
                )}
              </Row>
              <Row className="headerrow">
                <Row className="headerrow">
                  {getHeaderContent(
                    paymentContent,
                    paymentModalDetailsToDisplay
                  )}
                </Row>
              </Row>
              <Row className="messagerow">
              <span className="bold-red-large">
    {getContent(paymentContent, paymentModalDetailsToDisplay)}
  </span>            </Row>
            </>
            {paymentContent?.success?.button ? (
              <Row className="btnrow">
                <Button
                  // variant="outline-primary"
                  size="md"
                  className="buttondone"
                  onClick={windowClose}
                >
                  {paymentContent?.buttonText || "Done"}
                </Button>
              </Row>
            ) : (
              <></>
            )}
          </Container>
        </div>
      ) : null}

      {poweredBy && (
        <div className="signdesk_logo mb-1 d-lg-block d-md-block d-sm-none d-xs-none bottom-0 d-flex end-0 position-absolute pe-2 p-4">
          <span className="d-flex">
            <p>Powered by</p>
            <Image src={Signdesk_logo} alt="signDesk_logo" />
          </span>
        </div>
      )}
    </div>
  );
};

export default PaymentSucess;
